import {stripQueryParams} from "../utils/stringUtils";

function toggleMenu() {
    $('.hamburger').toggleClass('is-active');
    $('body').toggleClass('is-locked');
    $('.mobile-menu').toggleClass('mobile-menu--active');
    $('.mobile-menu__overlay').toggleClass('mobile-menu__overlay--active');
}

$('.hamburger, .mobile-menu__overlay').on('click', toggleMenu);

$('.list-view button').on('click', function () {
    const parent = this.parentNode;
    const $icon = $(this).find('svg');

    $icon.toggleClass('list-view__icon--active');
    $(parent.nextElementSibling).slideToggle();
});

$('.list-view__item a').each(function () {
    const menuItemUrl = $(this).attr('href');
    const $parent = $(this).parent();
    const defaultHref = $(this).data('default-href');
    const currentPageUrl = window.location.href;

    if (currentPageUrl === menuItemUrl) {
        $parent.addClass('active');
    }

    if (defaultHref && stripQueryParams(currentPageUrl) === defaultHref) {
        $parent.addClass('active');
    }
});

$('.list-view__item.active').each(function () {
    let $parent = $(this).parent();
    let $highestParent = $parent.closest('ul');
    let $siblingListView = $highestParent.siblings('.list-view');
    let $childElement = $siblingListView.find('.list-view__item');
    let $siblingListViewIcon = $childElement.siblings('.list-view__icon');

    // Add the "active" class to the closest list-view
    $childElement.addClass('active');
    $siblingListViewIcon.addClass('active');
});